export default [
  {
    header: 'pto',
    permission: ['admin', 'pto']

  },
  {
    title: 'sidebar.pto',
    icon: 'CheckSquareIcon',
    route: 'pto',
    permission: ['admin', 'pto']

  },
]
